import { render, staticRenderFns } from "./mygames.vue?vue&type=template&id=1f29875c&scoped=true&"
import script from "./mygames.vue?vue&type=script&lang=js&"
export * from "./mygames.vue?vue&type=script&lang=js&"
import style0 from "./mygames.vue?vue&type=style&index=0&id=1f29875c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f29875c",
  null
  
)

export default component.exports